<app-route-sheet-list *ngIf="identifier != ''" 
                        [identifier]="this.identifier" 
                        [childCategory]="this.childCategory"
                        [parentCategory]="this.parentCategory"
                        [parentCoordX]="this.parentCoordX"
                        [parentCoordY]="this.parentCoordY"
                        (categoryTotal)="loadTotal($event)">
</app-route-sheet-list>